/*
*******************************************************************************************
This Enum is sorted alphabetically. Please consider this when you are adding new event type
*******************************************************************************************
*/

export enum ApplicationEventType {
  AddShippingInfo = 'Add Shipping Info',
  AddPaymentInfo = 'Add Payment Info',
  AddToCart = 'Add To Cart',
  AddToCartMoreThanInStock = 'More than in Stock Click',
  AlternativeProductsShow = 'Alternative Products Show',
  AssistedSales = 'Assisted Sales',
  Authorization = 'Authorization',
  BannerClickExperiment = 'Banner Click Experiment',
  BannerInteraction = 'Banner Interaction',
  ButtonClick = 'Button Click',
  CarouselButton = 'carouselButton',
  CarouselClick = 'carouselClick',
  CarouselItemsViewed = 'Carousel Items Viewed',
  CartUpdate = 'Cart Update',
  CartViewed = 'Cart Viewed',
  CategorySelected = 'Category Selected',
  CheckoutErrors = 'Checkout Errors',
  CheckoutStarted = 'Checkout Started',
  CheckoutStep = 'Checkout Step',
  CheckoutStepper = 'Checkout Stepper',
  ContentBanner = 'Content Banner',
  CookieBanner = 'Cookie Banner',
  CreateAccount = 'Create Account',
  CreateAccountExperiment = '',
  CustomLinkedGrid = 'Custom Linked Grid',
  EditorialLinkNavigationClick = 'Editorial Links Navigation',
  FeatureFlag = 'Feature Flag',
  FilterAreaInteraction = 'Filter Area Interaction',
  HomePageViewed = 'Home Page Viewed',
  Interaction = 'Interaction',
  IdamSignUp = 'IDAM Signup',
  SignUpToCheckoutTransition = 'SignUp to Checkout Transition',
  LogoutClick = 'Logout Click',
  Navigation = 'Navigation',
  Notification = 'Notification',
  Optimize = 'Optimize',
  OtherOffersViewed = 'Other Offers Viewed',
  PaymentCompleted = 'Payment Completed',
  PaymentFailure = 'Payment Failure',
  PdpDescriptionInteraction = 'PDP description interaction',
  PdpLoadbeeInteraction = 'Loadbee button clicked',
  PdpCompareAllOffersClick = 'compare_all_offers_click',
  PdpFurtherInformationInteraction = 'Further information about the product clicked',
  PdpImageInteraction = 'PDP image interaction',
  PdpWeeMoreDetailsClick = 'weee_details_click',
  PriceTypeChanged = 'Price Type Changed',
  ProductClick = 'Product Click',
  ProductDetailsViewed = 'Product Details Viewed',
  PromoImageLinkClick = 'Promo Image Link Clicked',
  FlixMediaContentViewed = 'Flix Media Content View',
  FlixMediaContentScroll = 'Flixmedia content scrolled',
  ProductListViewed = 'Product List Viewed',
  ViewItemsList = 'View Items List',
  ViewPromotion = 'View Promotion',
  SelectItem = 'SelectItem',
  SelectPromotion = 'Select Promotion',
  ProductsSorted = 'Products Sorted',
  Purchase = 'Purchase',
  PurchaseGA4 = 'PurchaseGA4',
  QuantityPickerInteraction = 'Quantity Picker Interaction',
  RemoveFromCart = 'Remove From Cart',
  ReviewOrderInfo = 'Review Order Info',
  Scrolling = 'Scrolling',
  Search_0_results = 'search_0_results',
  Search_0_results_click = 'search_0_results_click',
  Search_ZRP_category_view = 'category_viewed',
  Search_ZRP_other_buckets = 'bucket_viewed',
  Search_ZRP_other_buckets_clicked = 'bucket_clicked',
  Search = 'Search',
  CategoryPage = 'Category page',
  CategoryPageViewed = 'Category Page View',
  SearchInteraction = 'Search Interaction',
  SeoFaqToggle = 'Content FAQ',
  SimilarProductsView = 'Similar Products View',
  SuggestionSelected = 'Suggestion Selected',
  ThankyouPageViewed = 'Thankyou Page Viewed',
  TopNavbarCategoryMenuOpen = 'Top Navbar Category Menu Open',
  SeeAllPromotions = 'See All Promotions',
  VolumePriceViewed = 'Volume Price Viewed',
  VolumePriceTableClicked = 'Volume Price Table Clicked',
  PLPPaginationShowMoreClick = 'PLP Pagination Show More Click',
  OutOfStockNotifyClick = 'out-of-stock notify click',
  ExploreSimilarProductsClick = 'explore_similar_products click',
  PdpBrandInteraction = 'PDP brand interaction',
  PdpSellerInteraction = 'PDP seller interaction',
  PdpOtherOffersInteraction = 'Offer picker',
  PLPSeoText = 'Seo Text Viewed',
  CartLinkClick = 'Cart link click',
  OrderHistoryInteraction = 'Order history interaction',
  PLPPriceFilterInteraction = 'Price Filter interaction',
  PDPRegisterAsBusinessInteraction = 'PDP register as a business interaction',
  MiniCartInteraction = 'Mini cart interaction',
  PageView = 'Analytics initialization after cookie consent granted',
  LoadBeeButtonView = 'Loadbee button View',
  ProceedToCheckout = 'Proceed to checkout',
  CarouselSwipeInteraction = 'Carousel swipe interaction',
  RegistrationType = 'Registration Type Button Click',
  RegisterWithEmail = 'Register With Email',
  OfferPriceSyncIssue = 'Offer Price Sync Issue',
  NewsletterSubscription = 'Newsletter subscription',
  HubPageCardClick = 'Hub Page Card Click',
  PdpOfferMismatch = 'PDP Marketing Feed Offer Mismatch',
  FlixMediaContentFailed = 'Flix Media Content Failed 1',
  FlixMediaFailed = 'Flix Media failed',
  PDPFoodCategoryLink = 'Food Free Shipping Click',
  OptimizelyActivateExperiment = 'activate_experiment',
  OrderHistorySideMenuInteraction = 'order history side menu interaction',
  SearchBanner = 'search_banner_click',
  ContentCardClick = 'Content Cards Click',
  CategoryCardClick = 'Category Card Click',
  ZRPCategoryClicked = 'CategoryClicked',
  ViewCart = 'View Cart',
  RemoveItemFromCart = 'Remove Item From Cart',
  BeginCheckout = 'Begin Checkout',
  ViewItem = 'view_item',
  AddToCartGa4 = 'add_to_cart',
  ViewRecommendation = 'View Recommendation',
  SelectRecommendation = 'Select Recommendation',
  InstallationServices = 'Installation Services',
  InstallationServicesDetails = 'Installation Services Details',
  InstallationServicesDetailsLinks = 'Service Installation Link Click',
  ShowTooltipValueAddedService = 'Cart tooltip VAS interaction',
  CallbackClick = 'Callback Button Click',
  InvalidOfferForRegion = 'InvalidOfferForRegion',
  ChangeDeliveryAddress = 'ChangeDeliveryAddress',
  BackToCart = 'BackToCart',
  GA4General = 'GA4General',
  ImageSearchLogoHover = 'se_hover_image_search',
  ImageSearchLogoClick = 'se_image_search_logo_clicked',
}
